// extracted by mini-css-extract-plugin
export default {"icon":"ArtistSocial_icon__EMxha","iconos":"ArtistSocial_iconos__haMYw"};